import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import './ServerErrorComponent.css';

class ServerErrorComponent extends Component {
    render() {
        return (
            <div className='server-error-container'>
                <h2>{"500 - " + _.get(this.props.translation, 'server_error.server_error_label')}</h2>
                <h6>{_.get(this.props.translation, 'server_error.sorry_label')}</h6>
                <h6>{_.get(this.props.translation, 'server_error.cause_label')}</h6>
            </div>
        );
    }
}

ServerErrorComponent.propTypes = {
    translation: PropTypes.object.isRequired
};

export default ServerErrorComponent;



// WEBPACK FOOTER //
// ./src/components/commonComponents/serverErrorComponent/ServerErrorComponent.js